import { webKnots } from '../../../../common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const type7Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  ctx.moveTo(655, 184) // 星＿上
  ctx.quadraticCurveTo(530, 225, 530, 225) // 星＿左
  ctx.quadraticCurveTo(535, 244, 492, 277) // 星＿左下_左
  ctx.quadraticCurveTo(496, 285, 496, 285) // 星＿左下_右
  ctx.quadraticCurveTo(571, 250, 616, 270) //
  ctx.quadraticCurveTo(602, 308, 600, 323) // 星＿右下＿下
  ctx.quadraticCurveTo(643, 304, 643, 304) // 星＿右下＿上
  ctx.quadraticCurveTo(644, 275, 644, 275) //
  ctx.quadraticCurveTo(663, 303, 663, 303) //
  ctx.quadraticCurveTo(676, 292, 676, 292) //
  ctx.quadraticCurveTo(647, 256, 647, 256) //
  ctx.quadraticCurveTo(660, 192, 660, 192) //

  ctx.moveTo(645, 200) // 上
  ctx.quadraticCurveTo(552, 240, 552, 246) // 左下
  ctx.quadraticCurveTo(583, 237, 620, 260) // 右下
  ctx.quadraticCurveTo(645, 200, 645, 200) // 上

  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //
  // 内側＿左＿空間
  ctx.moveTo(555, 87) // 左上
  ctx.quadraticCurveTo(513, 166, 490, 250) // 左下
  ctx.quadraticCurveTo(496, 270, 496, 270) // 右下
  ctx.quadraticCurveTo(532, 242, 525, 222) // 星＿左下
  ctx.quadraticCurveTo(653, 181, 651, 183) // 星＿頂点
  ctx.quadraticCurveTo(617, 126, 555, 89) // 左上
  // 内側＿右上＿空間
  ctx.moveTo(661, 198) // 左上
  ctx.quadraticCurveTo(650, 254, 650, 254) // 左下
  ctx.quadraticCurveTo(674, 283, 675, 284) // 右下
  ctx.quadraticCurveTo(689, 272, 689, 272) // 右上
  ctx.quadraticCurveTo(675, 227, 661, 198) // 左上
  // 内側＿右下＿空間
  ctx.moveTo(505, 284) // 左下
  ctx.quadraticCurveTo(527, 325, 582, 352) // 右下
  ctx.quadraticCurveTo(615, 333, 656, 298) // 右上＿右
  ctx.quadraticCurveTo(646, 282, 646, 282) // 右上＿左
  ctx.quadraticCurveTo(647, 306, 647, 306) //
  ctx.quadraticCurveTo(596, 327, 596, 327) //
  ctx.quadraticCurveTo(600, 300, 613, 273) //
  ctx.quadraticCurveTo(574, 256, 505, 284) //
  // 内側＿内側＿三角形
  ctx.moveTo(640, 205) // 上
  ctx.quadraticCurveTo(560, 242, 560, 242) // 左下
  ctx.quadraticCurveTo(583, 237, 618, 255) // 右下
  ctx.quadraticCurveTo(640, 205, 640, 205) //
  // 横＿三角形部分
  ctx.moveTo(533, 133) // 左下
  ctx.quadraticCurveTo(582, 224, 596, 326) // 右下
  ctx.moveTo(534, 127) // 左下
  ctx.quadraticCurveTo(625, 200, 678, 282) // 右下

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
}
